import { Button, Grid, Typography } from '@mui/material';
import userSetPinLogo from 'assets/Images/Auth/authotp.png';
import EnterOtpInput from 'components/Common/EnterOtpInput';
import { getLocalStorageItem } from 'hooks';
import {
  useLogOutApiQuery,
  useSetIdelTimeQuery,
  useSetupNewPinQuery,
} from 'queries/AuthQueries';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from 'routes/RouteConstants';

const SetupPinPopup: FC<{
  setOpen: any;
  setPinScreen?: any;
}> = ({ setOpen, setPinScreen }) => {
  const { t } = useTranslation('setUpPin');
  const { handleSubmit } = useForm();
  const { username } = getLocalStorageItem('roles');
  const [otp, setOtp] = useState<String>('');
  const { mutate: setupPinApi } = useSetupNewPinQuery();
  const { mutate: setIdelTime } = useSetIdelTimeQuery();
  const { mutate: logoutApi } = useLogOutApiQuery();
  const navigate = useNavigate();
  const submitAuthForm = () => {
    const pinPayload: any = {
      passcode: otp.toString(),
      onboardingMode: null,
    };
    setupPinApi(pinPayload, {
      onSuccess: () => {
        setOpen(false);
        setPinScreen(false);
      },
    });
  };
  useEffect(() => {
    if (otp?.length === 4) {
      submitAuthForm();
    }
  }, [otp]);

  const handleLogout = () => {
    logoutApi(null, {
      onSuccess: () => {
        setIdelTime(
          {
            status: false,
          },
          {
            onSuccess: () => {
              localStorage.clear();
              navigate(routes.LOGIN.pathname);
            },
            onError: () => {},
          }
        );
      },
      onError: (err: any) => {},
    });
  };
  const handleAuthErrors = () => {};

  return (
    <div className="mx-auto max-w-md rounded-lg p-4">
      <div className="mb-4 text-center">
        <img src={userSetPinLogo} alt="" className="mx-auto mb-3" />
        <Typography
          fontWeight={600}
          variant="h5"
          color="secondary.100"
          align="center"
        >
          {t('setUpPin')}
        </Typography>
      </div>

      <form
        id="pin-form"
        onSubmit={handleSubmit(submitAuthForm, handleAuthErrors)}
      >
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <EnterOtpInput
              value={otp}
              otpDigit={4}
              onChange={(userOTP: string) => {
                setOtp(userOTP);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              fontWeight={400}
              variant="subtitle1"
              color="font.900"
              className="ml-2 pb-2 text-center"
            >
              {t('pinBenefit')}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              id="pin-form"
              fullWidth
              disabled={otp?.length < 4}
            >
              {t('confirm')}
            </Button>

            <Typography
              fontWeight={400}
              variant="subtitle1"
              color="font.900"
              className="pt-2 text-center"
            >
              {t('userId')}
              <span className="font-bold text-[#2A323D]"> {username} </span>
              <span
                className="ml-2 cursor-pointer font-semibold text-[#088AB2]"
                onClick={handleLogout}
              >
                {t('logout')}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default SetupPinPopup;
